import {
    GET_COMPANY_SPOC_FAILURE,
    GET_COMPANY_SPOC_LOADING,
    GET_COMPANY_SPOC_SUCCESS,
  } from "../../actions/types";
  
  const initialState = {
    company: {
      get: {
        loading: false,
        success: {
          ok: false,
          data: null,
        },
        failure: {
          error: false,
          message: "",
        },
      },
    },
  };
  
  const getCompanySpocsReducers = (state = initialState, action) => {
    switch (action.type) {
      case GET_COMPANY_SPOC_LOADING:
        return {
          ...state,
          company: {
            ...state.company,
            get: {
              ...state.company.get,
              loading: true,
              reset: false,
              success: {
                ...state.company.get.success,
                ok: false,
              },
              failure: {
                error: false,
                message: "",
              },
            },
          },
        };
  
      case GET_COMPANY_SPOC_SUCCESS:
        return {
          ...state,
          company: {
              ...state.company,
              get: {
                  ...state.company.get,
                  loading: false,
                  reset: false,
                  success: {
                      ...state.company.get.success,
                      ok: true,
                      data: action.payload,
                  },
                  failure: {
                      error: false,
                      message: '',
                  },
              },
          },
        };
      case GET_COMPANY_SPOC_FAILURE:
        return {
          ...state,
          company: {
              ...state.company,
              get: {
                  ...state.company.get,
                  loading: false,
                  reset: false,
                  success: {
                      ...state.company.get.success,
                      ok: false,
                      data: null,
                  },
                  failure: {
                      error: true,
                      message: action.payload.message,
                  },
              },
          },
        };
      default:
        return state;
    }
  };
  
  export default getCompanySpocsReducers;
  